import { axiosClassic } from '../api';

const NEWS_ALL = ['news'] as const;

export const NEWS_KEYS = {
  all: NEWS_ALL,
  feed: (page: number) => [...NEWS_ALL, 'feed', page] as const,
  detail: (id: number) => [...NEWS_ALL, 'detail', id] as const,
  types: [...NEWS_ALL, 'types'] as const,
};

export interface INewsFile {
  id: string;
  fieldId: number;
  fileName: string;
  mimeType: string;
  characterSet: string | null;
  fileType: string;
  newsId: number;
  originFileName: string;
  createdDate: string;
}

export interface IShortNews {
  id: number;
  titleUa: string;
  descriptionUa: string;
  headerImgId: string | null;
  createDate: string | null;
}

export interface INews extends IShortNews {
  textUa: string | null;
  newsType: string;
  files: INewsFile[];
}

export interface INewsResponse {
  data: IShortNews[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface ISingleNewsResponse {
  news: INews;
  similarNews: IShortNews[];
}

export interface IGetNewsParams {
  page?: number;
  limit?: number;
  newsType?: string;
}

class NewsService {
  private BASE_URL = '/news';

  async getNewsFeed(params: IGetNewsParams): Promise<INewsResponse> {
    const { data } = await axiosClassic.get<INewsResponse>(this.BASE_URL, { params });
    return data;
  }

  async getSingleNews(id: number): Promise<ISingleNewsResponse> {
    const { data } = await axiosClassic.get<ISingleNewsResponse>(`${this.BASE_URL}/${id}`);
    return data;
  }

  async getNewsTypes(): Promise<string[]> {
    const { data } = await axiosClassic.get<string[]>(`${this.BASE_URL}/types`);
    return data;
  }

  getImageUrl(fileId: string): string {
    if (!fileId) return '';
    const baseUrl = axiosClassic.defaults.baseURL || '';
    return `${baseUrl}${this.BASE_URL}/image/${fileId}`;
  }
}

export const newsService = new NewsService();